export default __webpack_public_path__ + "static/media/payment-plan-deposit-four.6e37336e.png";